import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Box, Button, IconButton, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CachedIcon from '@material-ui/icons/Cached';
import useUserInfo from 'src/hooks/user/use-user-info';
import { ErrorSerialNoList } from 'src/types';

interface Props {
  onClearAll: () => void;
  onRetry: (index: number) => void;
  onRemove: (index: number) => void;
  transactionErrorList?: ErrorSerialNoList;
}

const Component = ({
  transactionErrorList = [],
  onRetry,
  onRemove,
  onClearAll
}: Props) => {
  const { userBranchNameViaId } = useUserInfo();

  return (
    <Box>
      {transactionErrorList.length > 0
        ? transactionErrorList?.map((errorSN, index) => (
            <Alert
              style={{ marginBottom: 1 }}
              key={`${errorSN?.serial_no}${index}`}
              severity="error"
              action={
                <div>
                  <Tooltip title="Retry" placement="top">
                    <IconButton
                      aria-label="retry"
                      color="inherit"
                      size="medium"
                      onClick={() => {
                        onRetry(index);
                      }}
                    >
                      <CachedIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Remove" placement="top">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="medium"
                      onClick={() => {
                        onRemove(index);
                      }}
                    >
                      <DeleteOutlineIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </div>
              }
            >
              <AlertTitle>
                {errorSN?.serial_no} - {userBranchNameViaId(errorSN?.branch_id)}
              </AlertTitle>
              {errorSN?.message}
            </Alert>
          ))
        : null}
      {transactionErrorList.length > 0 ? (
        <Box display="flex" justifyContent="flex-end">
          <Button onClick={onClearAll} color="secondary">
            Clear All Invalid Serial No(s)
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export const TransactListError = React.memo(Component);
